import NsButtonActionsGroup from "../../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../../components/buttons/NsButtonAction";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import React from "react";

export default function TabellaClassiTipiImpExpDatiViewr({
                                                             classiImpExp,
                                                             translate,
                                                             onRowDbClickClasse,
                                                             onClickElimina
                                                         }) {

    return (
        <NsDataTable
            data={classiImpExp}
            columns={[
                {
                    name: translate('Codice'),
                    selector: row => row.codice,
                    sortable: true,
                },
                {
                    name: translate('Descrizione'),
                    selector: row => row.descrizione,
                    sortable: true,
                },
                {
                    name: translate('Icona'),
                    selector: row => <i className={row.icona}/>,
                    sortable: false,
                },
                {
                    name: '',
                    selector: row => <NsButtonActionsGroup>
                        <li>
                            <NsButtonAction
                                href={"/upd-classe-imp-exp/" + row.id_classe_tipo_imp_exp}
                                label={"Modifica"}
                                icona={"fas fa-pen"}
                            />
                        </li>
                        <li>
                            <NsButtonAction
                                label={"Elimina"}
                                icona={"fas fa-trash"}
                                onClick={() => {
                                    onClickElimina(row);
                                }}
                            />
                        </li>
                    </NsButtonActionsGroup>,
                    sortable: false,
                    right: true,
                }
            ]}
            onRowDbClick={onRowDbClickClasse}
        />
    );
}